module.exports = __webpack_public_path__ + "img/1-collaboration-solutions.646a5bb5.png";